import * as i0 from "@angular/core";
export class LogoStore {
}
LogoStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogoStore_Factory() { return new LogoStore(); }, token: LogoStore, providedIn: "root" });
export var LogoStoreKeys;
(function (LogoStoreKeys) {
})(LogoStoreKeys || (LogoStoreKeys = {}));
